
const data = [
  {
    title: '组织发展概述',
    description: '企业在组织各种形态中最具代表性，企业在资源综合利用的效率集中体现在组织设计及组织运营效率上。组织发展是针对组织设计和组织运行模式的再造性设计，提升组织对业务的保障和促进作用。'
  },
  {
    title: '服务内容',
    description: '业务架构设计\n组织架构设计\n组织职责梳理\n职位体系设计'
  },
  {
    title: '服务特点',
    description: '' +
      '深入洞察战略、产品、能力、决策等因素，基于未来业务承载能力设计；\n' +
      '深入细致的变革路径和操作方法，企业拿来可用；\n' +
      '深入业务，理解业务，梳理业务，完整为客户贴身设计。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/hr-grow.js